module.exports = __webpack_public_path__ + "static/banner.hire-9cc5a38694b1c7a48be0403773a73088.png";